import { render, staticRenderFns } from "./RipaOfficer.vue?vue&type=template&id=1370b304"
import script from "./RipaOfficer.vue?vue&type=script&lang=js"
export * from "./RipaOfficer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports